import { render, staticRenderFns } from "./monthly-closing-summary.vue?vue&type=template&id=65063f8c&scoped=true&"
import script from "./monthly-closing-summary.vue?vue&type=script&lang=js&"
export * from "./monthly-closing-summary.vue?vue&type=script&lang=js&"
import style0 from "./monthly-closing-summary.vue?vue&type=style&index=0&id=65063f8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65063f8c",
  null
  
)

export default component.exports